module.exports = new __parcel__URL__("mid-tom_11.58388abe.mp3").toString();